// import React from 'react'

// function Trademarks() {
//   return (
//     <>
//         <head>
//             <title>خدمة المحاسبة</title>
//             <meta name="description" content="تقدم هذه الخدمه تسجيل العلامات التجارية - نقل العلامات التجارية - تعديل العلامات التجارية" />
//             <meta name="keywords" content="تسجيل علامة تجارية ، نقل علامة تجارية , الاعتراض على تسجيل علامة تجارية , تجديد العلامة التجارية , تعديل صورة العلامة التجارية"/>
//         </head>
//         <div>
//             <ul>
//                 <li>تسجيل العلامة التجارية</li>
//                 <li>نقل العلامة التجارية</li>
//                 <li>تعديل العلامة التجارية</li>
//                 <li>حق الانتفاع بالعلامة التجارية</li>
//                 <li>تعديل صورة العلامة التجارية</li>
//                 <li>الاعتراض على تسجيل العلامة التجارية</li>
//                 <li>رهن العلامة التجارية</li>
//                 <li>فك رهن العلامة التجارية</li>
//                 <li>تجديد العلامة التجارية</li>
//             </ul>
//         </div>
//     </>
//   )
// }

// export default Trademarks


import React from 'react';

function Trademarks() {
  const services = [
    {
      title: "تسجيل العلامة التجارية",
      icon: "📝",
      description: "خدمة تسجيل العلامات التجارية بشكل رسمي وحماية حقوقك"
    },
    {
      title: "نقل العلامة التجارية",
      icon: "🔄",
      description: "نقل ملكية العلامة التجارية بين الأطراف بشكل قانوني"
    },
    {
      title: "تعديل العلامة التجارية",
      icon: "✏️",
      description: "تعديل بيانات العلامة التجارية المسجلة بشكل رسمي"
    },
    {
      title: "حق الانتفاع بالعلامة التجارية",
      icon: "⚖️",
      description: "الترخيص باستخدام العلامة التجارية للغير"
    },
    {
      title: "تعديل صورة العلامة التجارية",
      icon: "🎨",
      description: "تعديل الشكل البصري للعلامة التجارية"
    },
    {
      title: "الاعتراض على تسجيل العلامة التجارية",
      icon: "🚫",
      description: "تقديم اعتراض على تسجيل علامة تجارية مسجلة"
    },
    {
      title: "رهن العلامة التجارية",
      icon: "🔒",
      description: "استخدام العلامة التجارية كضمان للقروض"
    },
    {
      title: "فك رهن العلامة التجارية",
      icon: "🔓",
      description: "إزالة الرهن عن العلامة التجارية بعد سداد الديون"
    },
    {
      title: "تجديد العلامة التجارية",
      icon: "🔄",
      description: "تجديد تسجيل العلامة التجارية بعد انتهاء مدة الحماية"
    }
  ];

  return (
    <>
    <header className="max-w-4xl mx-auto text-center mb-16" style={{height:"auto",marginBottom:"3px"}}>
        <h1 className="text-4xl font-bold text-indigo-800 mb-4">خدمات العلامات التجارية</h1>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto">
          نقدم مجموعة متكاملة من خدمات العلامات التجارية لحماية حقوقك والمحافظة على هوية علامتك التجارية
        </p>
      </header>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
                <div 
                key={index} 
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-indigo-100"
                >
                <div className="p-6">
                    <div style={{display:"flex",gap:"5px",alignItems:"center"}}>
                        <div className="text-4xl mb-4">{service.icon}</div>
                        <h3 className="text-xl font-semibold text-indigo-700 mb-2">{service.title}</h3>
                    </div>
                    <p className="text-gray-600">{service.description}</p>
                </div>
                </div>
            ))}
            </div>
        </div>
        </div>
        
    </>
  );
}

export default Trademarks;
